// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { TrafficStatus } from './traffic-status';


export class TrafficStatusMessage implements flatbuffers.IUnpackableObject<TrafficStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):TrafficStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsTrafficStatusMessage(bb:flatbuffers.ByteBuffer, obj?:TrafficStatusMessage):TrafficStatusMessage {
  return (obj || new TrafficStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsTrafficStatusMessage(bb:flatbuffers.ByteBuffer, obj?:TrafficStatusMessage):TrafficStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TrafficStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():TrafficStatus {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : TrafficStatus.UpPilot;
}

static startTrafficStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:TrafficStatus) {
  builder.addFieldInt16(0, message, TrafficStatus.UpPilot);
}

static endTrafficStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createTrafficStatusMessage(builder:flatbuffers.Builder, message:TrafficStatus):flatbuffers.Offset {
  TrafficStatusMessage.startTrafficStatusMessage(builder);
  TrafficStatusMessage.addMessage(builder, message);
  return TrafficStatusMessage.endTrafficStatusMessage(builder);
}

unpack(): TrafficStatusMessageT {
  return new TrafficStatusMessageT(
    this.message()
  );
}


unpackTo(_o: TrafficStatusMessageT): void {
  _o.message = this.message();
}
}

export class TrafficStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: TrafficStatus = TrafficStatus.UpPilot
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return TrafficStatusMessage.createTrafficStatusMessage(builder,
    this.message
  );
}
}
